<template>
  <div>
    <el-dialog :title="'子账号'" :visible="true" :before-close="closeForm" :close-on-click-modal="false"
      :close-on-press-escape="false" width="80%">
      <el-form label-width="100px" class="demo-ruleForm">
        <div style="padding: 0 10px 10px 0">
          <el-button type="primary" @click="showAdd()">新增子账号</el-button>
        </div>
      </el-form>

      <el-table :data="subAccountList" border style="width: 100%">
        <el-table-column prop="id" label="id"> </el-table-column>
        <el-table-column prop="agentid" label="总代id"> </el-table-column>
        <el-table-column prop="vendorid" label="加盟商id"> </el-table-column>
        <el-table-column prop="subLoginAccount" label="子账号名称"> </el-table-column>
        <el-table-column prop="mobile" label="手机"></el-table-column>
        <el-table-column label="创建时间" width="240px">
          <template slot-scope="scope">
            <div>{{ scope.row.createtime | formatDateTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
            <!-- </template> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <AddSubAccountDialog v-if="isAddSubAccountDialog" @closeAddSubAccount="closeAddSubAccount" @refresh="querySubAccout"
      :agentid="row.agentid" :vendorid="row.vendorid" />
  </div>
</template>
<script>
//import { mapGetters } from "vuex";

import AddSubAccountDialog from "./addSubAccountDialog";

export default {
  props: ["row"],
  components: {
    AddSubAccountDialog
  },
  data () {
    return {

      isAddSubAccountDialog: false,

      subAccountList: [],
      userType: this.$getUserType()
    };
  },
  methods: {
    closeForm () {
      this.$emit("closeForm");
    },

    closeAddSubAccount () {
      this.isAddSubAccountDialog = false
    },

    querySubAccout () {
      let queryModel = {
        agentid: this.row.agentid,
        vendorid: this.row.vendorid
      };
      console.log(queryModel)
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["子账号查询"], {
          data: queryModel
        }).then(result => {
          this.subAccountList = result.data;
          resolve();
        });
      });
    },


    handleDelete (item) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = item.id;
        this.$axios(this.$urlMapping["子账号删除"], {
          data: {
            id
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.querySubAccout();
        });
      });
    },


    showAdd () {
      this.isAddSubAccountDialog = true
    }
  },

  async mounted () {
    // console.log('mounted')
    // console.log(this.userType)
    // console.log(this.row)
    if (this.userType === "admin") {
      await this.querySubAccout();
    }
  }
};
</script>

<style lang="less" scoped></style>
